import React from 'react'
import './Sesvan.scss'
import StrategyIco from '../Images/strategy-ico.avif'
import CreativityIco from '../Images/creativity-ico.avif'
import BeyondIco from '../Images/beyond-ico.avif'
import SesvanFoto from '../Images/sesvan-photo.avif'

const Sesvan = () => {
    return (
        <div className='sesvan full-width' id='projects'>
            <div className='content main-grid'>
                <div className='first-title-div'>
                    <div className='col-one'>
                        <h3 className='first-title unbounded-font'>
                            Unleash the power<br /> of passion.
                        </h3>

                    </div>
                    <div className='col-two'>

                        <p className='inter-font'>
                            Our premium e-commerce solutions<br /> redefine excellence!
                        </p>

                    </div>
                    <div className='col-three'>
                        <img src={StrategyIco} alt='' className='deco-icon strategy-icon' />
                        <img src={CreativityIco} alt='' className='deco-icon creativity-icon' />
                        <img src={BeyondIco} alt='' className='deco-icon beyond-icon' />
                    </div>
                </div>
                <div className='client-description1'>
                    <div className='client-text'>
                        <h4 className='client-name unbounded-font'>Sesvan</h4>

                        <p className='desc-big inter-font'>
                            For the SESVAN brand, a fully adapted website was developed, meeting customer <br /> expectations and specific market requirements.
                        </p>


                        <p className='desc-small inter-font'>
                            We have conducted numerous studies to identify key areas of concentration for the brand. Our strategy has been a significant success, which is confirmed by the results of our activities.
                        </p>

                    </div>
                    <div className='client-foto'>
                        <img src={SesvanFoto} alt='sesvan portfolio' />

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sesvan